import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  LoginSubjectLinksInstalledUsersService,
  LoginSubjectLinksInstalledUsersDTOModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';
@Component({
  selector: 'app-person-in-charge',
  templateUrl: './person-in-charge.component.html',
  styleUrls: ['./person-in-charge.component.css']
})
export class PersonInChargeComponent implements OnInit, OnDestroy {

  @Input() pic: FormControl;
  @Input() required: boolean;
  @Input() mode: string;
  @Input() appletGuid: string;
  @Input() currentSubjectGuid: string;
  @Output() selectionChange = new EventEmitter();
  @Input() isDropdownDisabled: boolean = false; 
  @Input() disabled: boolean = false;

  private subs = new SubSink();
  fieldLabel = 'Person In Charge (PIC)';
  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<LoginSubjectLinksInstalledUsersDTOModel[]> =
    new ReplaySubject<LoginSubjectLinksInstalledUsersDTOModel[]>(1);
  entityList: LoginSubjectLinksInstalledUsersDTOModel[];

  constructor(private loginSubjectLinksInstalledUsers: LoginSubjectLinksInstalledUsersService) { }

  ngOnInit() {
    if(this.isDropdownDisabled){
      this.pic.disable()
    } else {
      this.pic.enable()
    }
    this.subs.sink = this.loginSubjectLinksInstalledUsers.getByAppletGuid(
      this.appletGuid, this.apiVisa).subscribe(
        {
          next: resolve => {
            this.entityList = resolve.data;
            this.filteredOptions$.next(this.entityList);

            // auto populate with current logged in user in create mode
            // since everyone that installs this app is a valid employee
            if (this.mode === 'create' && !this.pic.value) {
              if (this.entityList.filter(e =>
                e.subject_guid.toString() === this.currentSubjectGuid).length === 1) {
                this.pic.setValue(this.currentSubjectGuid);
              }
            }
          }
        });
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({ next: resolve => this.filterOptions(resolve) });
  }

  filterOptions(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter(c => c.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}